// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2636) return "static/chunks/2636-dcd1ad462da315dd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"20":"2c5ec5d3503d8925","821":"38c198421d27b0f9","1628":"5ff4acb08a1b9d46","2163":"8f9e8fcc5eec7727","5128":"4a1dd30a214c7c49","5325":"555e560a8ee7b7ac","7008":"294e20d8f630dfc5","8521":"644d701706e011a6","8721":"b3fa1e386741a73e","8828":"7fcf56ef0025c71f","9408":"05d728a954ad511e"}[chunkId] + ".js";
};